module.exports = __webpack_public_path__ + "img/gestaltra_logo_grey.7615d008.png";